<script setup lang="ts">
  import { useApiRequestsAbort } from '@/shared/composables'
  import { computed, defineAsyncComponent } from 'vue'
  import { useFeaturesStore } from '@/shared/store/featuresStore'

  const FlowDestinationWidget = defineAsyncComponent(
    () => import('@/widgets/Flow/FlowDestinationWidget/FlowDestinationWidget.vue')
  )
  const FlowDestinationWidgetQC = defineAsyncComponent(
    () => import('@/widgets/Flow/FlowDestinationWidgetQC/FlowDestinationWidgetQC.vue')
  )

  const featuresStore = useFeaturesStore()
  const isFirstStepQcEnabled = computed(() => featuresStore.isFirstStepQcEnabled)
  useApiRequestsAbort()
</script>

<template>
  <FlowDestinationWidgetQC v-if="isFirstStepQcEnabled" />
  <FlowDestinationWidget v-else />
</template>
